var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatusBall',{attrs:{"status-mapping":_vm.statusMapping,"status":_vm.status}})}
var staticRenderFns = []

export { render, staticRenderFns }